"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemainingChars = void 0;
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./RemainingChars.module.css"));
var RemainingChars = (function (_super) {
    __extends(RemainingChars, _super);
    function RemainingChars(props) {
        return _super.call(this, props) || this;
    }
    RemainingChars.prototype.render = function () {
        var _a = this.props, maxLength = _a.maxLength, value = _a.value;
        return (react_1.default.createElement("div", { className: styles.root },
            react_1.default.createElement("span", { className: styles.counter },
                react_1.default.createElement("strong", null, value.length)),
            " ",
            react_1.default.createElement("span", null, " / "),
            " ",
            react_1.default.createElement("span", null,
                react_1.default.createElement("strong", null, maxLength)),
            " ",
            react_1.default.createElement("span", null, "characters remaining")));
    };
    return RemainingChars;
}(react_1.Component));
exports.RemainingChars = RemainingChars;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmVtYWluaW5nQ2hhcnMuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL1JlbWFpbmluZ0NoYXJzL1JlbWFpbmluZ0NoYXJzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDZDQUFzQztBQUN0QyxrRUFBcUQ7QUFPckQ7SUFBb0Msa0NBQW9CO0lBQ3BELHdCQUFZLEtBQUs7ZUFDYixrQkFBTSxLQUFLLENBQUM7SUFDaEIsQ0FBQztJQUNNLCtCQUFNLEdBQWI7UUFDVSxJQUFBLEtBQXFCLElBQUksQ0FBQyxLQUFLLEVBQTlCLFNBQVMsZUFBQSxFQUFFLEtBQUssV0FBYyxDQUFBO1FBRXJDLE9BQU8sQ0FDSCx1Q0FBSyxTQUFTLEVBQUUsTUFBTSxDQUFDLElBQUk7WUFDdkIsd0NBQU0sU0FBUyxFQUFFLE1BQU0sQ0FBQyxPQUFPO2dCQUMzQiw4Q0FBVSxLQUFnQixDQUFDLE1BQU0sQ0FBVSxDQUN4QztZQUFDLEdBQUc7WUFDWCxrREFBZ0I7WUFBQyxHQUFHO1lBQ3BCO2dCQUNJLDhDQUFTLFNBQVMsQ0FBVSxDQUN6QjtZQUFDLEdBQUc7WUFDWCw0Q0FBTyxzQkFBc0IsQ0FBUSxDQUNuQyxDQUNULENBQUE7SUFDTCxDQUFDO0lBQ0wscUJBQUM7QUFBRCxDQUFDLEFBcEJELENBQW9DLGlCQUFTLEdBb0I1QztBQXBCWSx3Q0FBYyJ9